/* 🤖 this file was generated by svg-to-ts */
export const matIconSubdirectoryArrowRight: {
  name: 'subdirectory-arrow-right';
  data: string;
} = {
  name: 'subdirectory-arrow-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"/></svg>`
};
